import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchFaqs, deleteFaq } from "store/faqSlice";
import { useHistory } from "react-router-dom";

export default function FaqTable({ color }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { items: faqs, loading, error } = useSelector(
    (state) => state.faqs
  );

  useEffect(() => {
    dispatch(fetchFaqs());
  }, [dispatch]);

  const handleCreate = () => {
    history.push("/admin/faq/create");
  };

  const handleEdit = (id) => {
    history.push(`/admin/faq/edit/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this FAQ?")) {
      dispatch(deleteFaq(id));
    }
  };

  return (
    <div
      className={
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
        (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
      }
    >
      {/* Header */}
      <div className="rounded-t mb-0 px-4 py-3 border-0 flex justify-between">
        <h3
          className={
            "font-semibold text-lg " +
            (color === "light"
              ? "text-blueGray-700"
              : "text-white")
          }
        >
          FAQ List
        </h3>

        <button
          onClick={handleCreate}
          className="bg-lightBlue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-600"
        >
          + Create FAQ
        </button>
      </div>

      {/* Table */}
      <div className="block w-full overflow-x-auto">
        <table className="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
              {["Question", "Answer", "Active", "Created At", "Actions"].map(
                (h, i) => (
                  <th
                    key={i}
                    className={`px-6 py-3 text-xs uppercase font-semibold text-left ${
                      color === "light"
                        ? "bg-blueGray-50 text-blueGray-500"
                        : "bg-lightBlue-800 text-lightBlue-300"
                    }`}
                  >
                    {h}
                  </th>
                )
              )}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="5" className="text-center p-4 text-red-500">
                  {error}
                </td>
              </tr>
            ) : faqs.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  No FAQs found.
                </td>
              </tr>
            ) : (
              faqs.map((faq) => (
                <tr key={faq.id}>
                  <td className="px-6 py-4 text-sm">
                    {faq.question}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {faq.answer}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {faq.is_active ? "Yes" : "No"}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {new Date(faq.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <button
                      onClick={() => handleEdit(faq.id)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded mr-2 text-xs"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(faq.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded text-xs"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

FaqTable.defaultProps = {
  color: "light",
};

FaqTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
